import { createSlice } from '@reduxjs/toolkit';
import {
    riegoNodo,
} from '../actions/riegoNodo';


export const RiegoReducerNodo = createSlice({
    name: 'riegoNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(riegoNodo.pending, (state) => { state.loading = true })
            .addCase(riegoNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(riegoNodo.rejected, (state) => { state.loading = false })
    }
})
export default RiegoReducerNodo.reducer;